import {dbParent} from './utils';
import firebase from "firebase";
import _ from "lodash";

export const createUser = (project_id, user_data) => {
  return dbParent('projects').doc(project_id).collection('users')
    .add(user_data);
}

export const getRole = async (id) => {
  const users = await firebase.firestore()
    .collection('projects')
    .doc(id)
    .collection('users')
    .where('uid', '==', firebase.auth().currentUser.uid)
    .get();

  let role = null;

  await users.forEach((sub) => {
    const data = sub.data();
    if (data) {
      role = data.role;
    }
  });

  return role;
}

export const getUsersOptions = async (id) => {
  const result = [{label: 'Все пользователи', value: null}];

  const data = await firebase.firestore()
    .collection('projects')
    .doc(id)
    .collection('users')
    .get();

  await data.forEach((subDoc) => {
    let _data = subDoc.data();
    result.push({label: _data.name || _data.email, value: _data.uid});
  });


  return result;
}



// WEBPACK FOOTER //
// ./src/firestore/users.js